"use client";

import React from "react";
import { Container, Button } from "react-bootstrap";
import styles from "./HeroSection.module.css";
import Image from "next/image";

import HeroOne from "@/app/assets/hr1.svg";   // LEFT connector
import HeroTwo from "@/app/assets/hr2.svg";   // RIGHT connector
import { FaArrowRight } from "react-icons/fa"; // FontAwesome Icon
import Link from "next/link";

const HeroSection = () => {
  return (
    <section className={styles.heroSection}>
      <div className="container">
        <Container className={styles.centerContainer}>

          {/* LEFT FEATURE BLOCK */}
          <div className={styles.leftFeature}>

            {/* LEFT TEXT */}
            <div className={styles.leftTextBlock}>
              <h3>2Gbps</h3>
              <p>Bandwidth<br />Capable</p>
            </div>

            {/* LEFT CONNECTOR SVG */}
            <Image
              src={HeroOne}
              alt="Left Connector"
              className={styles.leftConnectorImg}
            />

          </div>

          {/* RIGHT FEATURE BLOCK */}
          <div className={styles.rightFeature}>

            {/* RIGHT CONNECTOR SVG */}
            <Image
              src={HeroTwo}
              alt="Right Connector"
              className={styles.rightConnectorImg}
            />

            {/* RIGHT TEXT */}
            <div className={styles.rightTextBlock}>
              <h3>24/7</h3>
              <p>On-Demand<br />Help, Anytime</p>
            </div>

          </div>

          {/* CIRCLE + CONTENT */}
          <div className={`${styles.circleWrapper} position-relative`}>

            <div className={styles.circleGlow}></div>

            <div className={styles.circleMask}>
              <video autoPlay muted loop playsInline className={styles.videoInside}>
                <source src="/hero-bg.webm" type="video/mp4" />
              </video>
            </div>

            <div className={styles.dottedRing}></div>

            <div className={`${styles.contentWrapper} position-absolute top-50 start-50 translate-middle `}>
 
              <div  className={`cornerBox`}>
                We make it simple
                <span className="bottom-left-h"></span>
                <span className="bottom-left-v"></span>
              </div>

              <h1 className={`text-white py-lg-5 lh-md ${styles.title}`}>
                Smart<br/>Configurations
              </h1>

              <p className={styles.subText}>
                Tell us what you&apos;re building, and our AI will match you
                with the perfect hosting setup and pricing—no specs needed.
              </p>

              <div className={styles.btnRow}>
                 <Link  href="http://ai.temok.com/" className="text-decoration-none" target="_blank">
                <Button className={styles.orangeBtn}  onClick={() => window.openVFChat()} >
                  Talk to our AI Architect <FaArrowRight className={styles.btnIcon} />
                </Button> 
                </Link>
                <Link href="/solutions">
                <Button className={styles.whiteBtn} variant="light">
                  Explore Our Solutions <FaArrowRight className={styles.btnIcon} />
                </Button>
                </Link>
              </div>
            
            </div>
          </div>

        </Container>
      </div>
    </section>
  );
};

export default HeroSection;
